import type { Components, Theme } from '@mui/material';

import { palette } from '../colors';
import { pxToRem } from '../utils';

export const getMuiTooltip = (rootFontSize = 16): Components<Theme>['MuiTooltip'] => ({
    styleOverrides: {
        tooltip: {
            backgroundColor: palette.background?.tertiary,
            fontSize: pxToRem(14, rootFontSize),
        },
        arrow: {
            color: palette.background?.tertiary,
        },
    },
});
